import { useContext } from 'react';
import { SearchResultsEvents } from 'components/SearchFormAndResults/SearchResultsEvents/SearchResultsEvents';
import { SearchResultsArticles } from 'components/SearchFormAndResults/SearchResultsArticles/SearchResultsArticles';
import { SearchResultsNoResults } from 'components/SearchFormAndResults/SearchResultsWrapper/SearchResultsNoResults';
import { Loading } from 'components/UI/Loading/Loading';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';
import './SearchResultsWrapper.scss';

export const SearchResultsWrapper = () => {
  const { eventsData, articlesData, isLoading } = useContext(SearchContext);

  const showNoResults =
    !eventsData?.events?.length && !articlesData?.contentPages?.length && !isLoading;
  const showArticlesResults = articlesData?.contentPages?.length > 0 && !isLoading;

  const results = isLoading ? (
    <Loading />
  ) : (
    <>
      {showNoResults ? <SearchResultsNoResults /> : <SearchResultsEvents />}
      {showArticlesResults && <SearchResultsArticles />}
    </>
  );

  const classes = ['search-results__container', isLoading ? 'is-loading' : ''].join(' ');

  return <div className={classes}>{results}</div>;
};
